import styled from 'styled-components';

export const SafetyContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  margin-top: 16px;
  margin-bottom: 10px;

  p {
    color: #000000;
    opacity: 80%;
    text-align: center;
    font-size: 12px;
  }
`;
